const searchFormSelector = '.js-search_form_redesign';
const searchInputSelector = '.js-search_input_redesign';
const searchInputClearSelector = '.js-search_input_clear_redesign';
const searchSpinnerSelector = '.js-search_input_loader_redesign';
const searchIconSelector = '.js-search_input_default_icon_redesign';
const searchTargetSelector = '.js-search_internal_target_redesign';
const searchHiddenClass = 'is_hidden';
window.up.compiler(searchFormSelector, form => {
    const input = form.querySelector(searchInputSelector);
    const clearButton = form.querySelector(searchInputClearSelector);
    const searchIcon = form.querySelector(searchIconSelector);
    const spinner = form.querySelector(searchSpinnerSelector);
    if (input && clearButton && searchIcon && spinner) {
        const updateVisualFeedback = (value) => {
            spinner.classList.add(searchHiddenClass);
            if (value === '') {
                searchIcon.classList.remove(searchHiddenClass);
                clearButton.classList.add(searchHiddenClass);
            }
            else {
                searchIcon.classList.add(searchHiddenClass);
                clearButton.classList.remove(searchHiddenClass);
            }
        };
        updateVisualFeedback(input.value);
        window.up.on(form, 'up:form:submit', undefined, () => {
            spinner.classList.remove(searchHiddenClass);
            searchIcon.classList.add(searchHiddenClass);
            clearButton.classList.add(searchHiddenClass);
        });
        window.up.on(form, 'up:fragment:inserted', searchTargetSelector, () => {
            updateVisualFeedback(input.value);
        });
        window.up.on(input, 'input', undefined, (ev) => {
            updateVisualFeedback(ev.target.value);
        });
        window.up.on(clearButton, 'click', undefined, () => {
            input.value = '';
            input.dispatchEvent(new Event('change'));
            input.dispatchEvent(new Event('input'));
            window.up.submit(searchFormSelector);
        });
    }
});
export {};
